import React from "react";
import { Ball } from "./Ball";
import { GAME_THEME } from "../lib/api";
import { CalendarClock, Layers } from "lucide-react";

const fmt = (d) =>
  new Date(d + "T00:00:00").toLocaleDateString("en-US", {
    weekday: "short", month: "short", day: "numeric", year: "numeric",
  });

export const LatestDrawCard = ({ data, game }) => {
  const t = GAME_THEME[game];
  if (!data) return null;
  const { latest, next_draw_date, total_draws } = data;
  return (
    <div
      className="rounded-2xl bg-zinc-900 border border-zinc-800 p-6 sm:p-8 relative overflow-hidden"
      data-testid="latest-draw-card"
    >
      <div
        className="absolute -top-16 -right-16 w-48 h-48 rounded-full opacity-[0.08] blur-2xl"
        style={{ backgroundColor: t.color }}
      />
      <div className="flex items-center justify-between mb-6">
        <span className="text-xs uppercase tracking-[0.2em] text-zinc-400 font-semibold">
          Latest Draw
        </span>
        <span className="text-xs font-mono text-zinc-500">{fmt(latest.draw_date)}</span>
      </div>

      <div className="flex flex-wrap items-center gap-2.5 mb-8">
        {latest.numbers.map((n) => (
          <Ball key={n} n={n} size="lg" />
        ))}
        <span className="text-zinc-600 px-1 text-xl">+</span>
        <Ball n={latest.special} special color={t.color} size="lg" />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="rounded-xl bg-zinc-950/60 border border-zinc-800 p-4" data-testid="next-draw">
          <div className="flex items-center gap-2 text-zinc-400 mb-1">
            <CalendarClock size={14} />
            <span className="text-[11px] uppercase tracking-wider font-semibold">Next Draw</span>
          </div>
          <div className="font-heading text-base" style={{ color: t.color }}>
            {next_draw_date ? fmt(next_draw_date) : "—"}
          </div>
          <div className="text-[11px] text-zinc-500 mt-0.5">Draws: {t.days}</div>
        </div>
        <div className="rounded-xl bg-zinc-950/60 border border-zinc-800 p-4">
          <div className="flex items-center gap-2 text-zinc-400 mb-1">
            <Layers size={14} />
            <span className="text-[11px] uppercase tracking-wider font-semibold">Draws Tracked</span>
          </div>
          <div className="font-mono font-bold text-2xl text-zinc-50">
            {total_draws.toLocaleString()}
          </div>
        </div>
      </div>
    </div>
  );
};
